import Layout4Admin1 from "components/layout/Layout4Admin1";
import { useNavigate, useParams } from "react-router-dom";
import Css from 'components/pages/admin/Customer.module.css';
import { useEffect, useState } from "react";
import ApiConection from "api_ref/ApiConection";
import { Breadcrumb } from "react-bootstrap";
import CustomerUpAddonFlow from "../components/forms/CustomerUpAddonFlow";

export default function UpgradeAddonPackagePage() {
    const api = new ApiConection();
    const navigate = useNavigate();
    const { id } = useParams();

    const [loading, setLoading] = useState(true);
    const [Register, setRegister] = useState(undefined);

    const handleBreadcrumbClick = (e) => {
        navigate('/company');
    };
    const handleBreadcrumbCompanyClick = (e) => {
        navigate(`/company/detail/${id}`);
    };

    const getRegister = async () => {
        setLoading(true);

        const response = await api.getData(`api/register/${id}`);

        if (response.status === true) {
            setRegister(response.data);
        }
        //console.log(response.data);
    }

    useEffect(() => {
        getRegister();
    }, [id])

    return (
        <Layout4Admin1 >
            <div className={Css.Block_Transparent}>
                <Breadcrumb>
                    <Breadcrumb.Item onClick={handleBreadcrumbClick}>รายการลูกค้า</Breadcrumb.Item>
                    <Breadcrumb.Item onClick={handleBreadcrumbCompanyClick}>{Register?.company_name}</Breadcrumb.Item>
                    <Breadcrumb.Item active>อัปเกรดแพ็กเกจเสริม</Breadcrumb.Item>
                </Breadcrumb>
                <div className='contrainer'>
                    <CustomerUpAddonFlow registerData={Register} />
                </div>
            </div>
        </Layout4Admin1>
    )
}